<template>
  <div class="switch">
    <input
      :id="id"
      class="switch__input"
      type="checkbox"
      :checked="modelValue"
      @change="toggle"
    >
    <label class="switch__label" :for="id">
      <span class="switch__toggle">
        <slot />
      </span>
    </label>
  </div>
</template>

<script lang="ts" setup>
  const emit = defineEmits(['update:modelValue']);
  const id = useId();

  const toggle = (event) => {
    emit('update:modelValue', event.target.checked);
  };

  defineProps<{
    modelValue?: boolean
  }>();
</script>

<style src="~/assets/styles/components/atomic/switch.scss" lang="scss" />